// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"TipoServicioDetalle_spinnerContainer__7fsCV"};